/* src/app/shared/components/flow-checkbox-v2/flow-checkbox-v2.component.scss */
:host {
  display: inline-flex;
}
.checkbox-field {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}
.checkbox-field.disabled .checkbox-field__label {
  color: #a1a1aa;
  cursor: not-allowed;
}
.checkbox-field__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.checkbox-field__label {
  color: #18181b;
  cursor: pointer;
}
.checkbox {
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  justify-content: center;
  align-items: center;
  vertical-align: top;
  gap: 10px;
  background-color: #ffffff;
  border: 1px solid #a1a1aa;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
}
.checkbox.has-content {
  margin: 2px 0;
}
.checkbox:hover {
  background-color: #fafafa;
  border: 1px solid #a1a1aa;
}
.checkbox:focus-visible {
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(89, 113, 197, 0.5);
}
.checkbox.destructive:focus-visible {
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(220, 38, 38, 0.5);
}
.checkbox.filled {
  background-color: #4568d0;
}
.checkbox.filled:hover {
  background-color: #5580dc;
}
.checkbox.disabled {
  background-color: #f4f4f5;
  cursor: not-allowed;
}
.checkbox.disabled:hover {
  background-color: #f4f4f5;
}
.checkbox.destructive {
  background-color: #fef2f2;
  border: 1px solid #b91c1c;
}
.checkbox.destructive:hover {
  background-color: #fef2f2;
}
.checkbox.destructive.filled {
  background-color: #b91c1c;
}
.checkbox.destructive.filled:hover {
  background-color: #dc2626;
}
.checkbox.radio {
  border-radius: 50%;
  border: 1px solid #a1a1aa;
}
.checkbox.radio.filled {
  border: 1px solid transparent;
}
.checkbox.radio.disabled {
  border: 1px solid #a1a1aa;
}
.checkbox.radio.destructive {
  border: 1px solid #b91c1c;
}
.checkbox.radio.destructive.filled {
  background-color: #b91c1c;
  border: 1px solid transparent;
}
.checkbox.radio.destructive.filled:hover {
  background-color: #b91c1c;
}
.checkbox .radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.checkbox .check-img {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}
.checkbox .check-img.disabled {
  filter: brightness(0) saturate(100%) invert(87.5%);
}
/*# sourceMappingURL=flow-checkbox-v2.component.css.map */
